// extracted by mini-css-extract-plugin
export var securityHero = "hero-module--security-hero--+J4bg";
export var securityHero__title = "hero-module--security-hero__title--u+qAH";
export var securityHero__desc = "hero-module--security-hero__desc--CQYbH";
export var securityHero__gradient = "hero-module--security-hero__gradient--y3+XB";
export var securityHero__gradient_mobile = "hero-module--security-hero__gradient_mobile--olZuK";
export var securityHero__gradient_desktop = "hero-module--security-hero__gradient_desktop--BiPe9";
export var securityHero__gradient_tablet = "hero-module--security-hero__gradient_tablet--DTGJO";